module.exports = "/_next/static/images/LetEngineersFocused@3x-b8d234e2e69f715c88c657d32c007faf.webp";